<template>
  <div class="cost_send">
    <header-back
      :title="sendModalTit"
      @back="toBack"
    />
    <router-view />
    <cube-button
      v-if="showSendBtn"
      type="submit"
      :disabled="disabledSubmit"
      class="send_submit_btn"
      @click="sendMaintain"
    >
      {{ sendModalTit }}
    </cube-button>
  </div>
</template>

<script type="text/ecmascript-6">
import headerBack from '@/components/mobile/HeaderBack'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: { headerBack },
  data () {
    return {
      showSendBtn: true
    }
  },
  computed: {
    ...mapState('costMaintain/costDetail', ['sendSelectTree']),
    ...mapState(['baseinfo']),
    costId () {
      const { id } = this.$route.query
      return id
    },
    period () {
      const { period } = this.$route.query
      return period
    },
    key () {
      const { key } = this.$route.query
      return key
    },
    routeName () {
      return this.$route.name
    },
    disabledSubmit () {
      return JSON.stringify(this.sendSelectTree) === '{}'
    },
    sendModalTit () {
      return this.$t('message["274"]')
    }
  },
  watch: {
    $route (newVal) {
      const { name } = newVal
      this.showSendBtn = !(name === 'CostSendSelect')
    },
    baseinfo (newVal) {
      document.title = this.$t('message["274"]') + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  created () {
    this.makeSureSelect()
    this.showSendBtn = !(this.routeName === 'CostSendSelect')
  },
  methods: {
    ...mapActions('costMaintain/costDetail', ['sendCost']),
    ...mapMutations('costMaintain/costDetail', ['clearSendSelectTree']),
    toBack () {
      this.$router.push({ name: 'CostDetail', query: { period: this.period, key: this.key } })
    },
    // 发送
    sendMaintain () {
      let params = Object.assign({}, { id: this.costId }, { sendtoid: this.sendSelectTree.value })
      this.toSendCost(params)
    },
    async toSendCost (params) {
      const chain = await this.sendCost(params)
      chain.onSuccess(res => {
        this.$selefToast({
          text: this.$t('message["275"]')
        })
        this.clearSendSelectTree()
      })
        .onFail(err => {
          this.$selefToast({
            text: err,
            type: 'error'
          })
        })
        .fetch()
    },
    makeSureSelect () {
      this.$router.push({ name: 'CostSelectMain', query: { id: this.costId, key: this.key, period: this.period } })
    }
  }
}
</script>

<style scoped lang="scss">
.cost_send {
  height: 100%;
  position: relative;
  .send_submit_btn {
    position: fixed;
    bottom: 8px;
    width: 359px;
    background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
    box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
    border-radius:4px;
    border:1px solid rgba(80,119,170,1);
    margin: 8px;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
  }
  .foot-main {
    position: fixed
  }
}
</style>
